import React from 'react';
import { Reveal } from './Reveal';
const rows = [{
  feature: 'Vacaciones o viaje largo con los chicos',
  without: 'Volvés a improvisar como antes del Kit',
  with: 'Sistema armado para esos días también'
}, {
  feature: 'Fin de año / vacaciones de invierno',
  without: 'Días largos sin plan = vuelta a las pantallas',
  with: 'Actividades pensadas para tiempo extendido'
}, {
  feature: 'Fines de semana largos / feriados',
  without: 'Se pierden en trámites y descanso',
  with: 'Momentos de conexión ya planificados'
}];
export function UpsellComparison() {
  return <section aria-label="Qué agrega Vacaciones Presentes" className="w-full bg-cream-100 py-16 sm:py-20" data-id="element-229" data-mp="39ndf3au0koaj">
      <div className="mx-auto max-w-3xl px-5 sm:px-8" data-id="element-230" data-mp="34otqf2o1cyeh">
        <Reveal data-id="element-231" data-mp="1y9su2vv3me7d">
          <h2 className="text-center font-display text-2xl font-semibold tracking-tight text-bark-900 sm:text-3xl" data-id="element-232" data-mp="1yaay4eo05wpu">
            ¿Qué agrega Vacaciones Presentes?
          </h2>
        </Reveal>

        <Reveal delay={0.06} data-id="element-233" data-mp="37ym7ie0y61d3">
          <div className="mt-8 overflow-hidden rounded-3xl border border-bark-800/10 bg-cream-50 shadow-sm" data-id="element-234" data-mp="37zdu4zckgor8">
            <table className="w-full border-collapse text-left" data-id="element-235" data-mp="3cx5ri8vzd32t">
              <caption className="sr-only" data-id="element-236" data-mp="2yx4jm9hasvdu">
                Diferencias entre el Kit base y el Kit con Vacaciones Presentes
              </caption>
              <thead data-id="element-237" data-mp="33z3o5morxycd">
                <tr className="bg-cream-200" data-id="element-238" data-mp="2p8mifr53wm9o">
                  <th scope="col" className="px-4 py-4 text-xs font-bold uppercase tracking-wider text-bark-600 sm:px-6 sm:text-sm" data-id="element-239" data-mp="2p6tg2o1j0o7h">
                    Incluye
                  </th>
                  <th scope="col" className="px-3 py-4 text-center text-xs font-bold uppercase tracking-wider text-bark-400 sm:px-4 sm:text-sm" data-id="element-240" data-mp="2g8zi78o45mi7">
                    ❌ Solo Kit base
                  </th>
                  <th scope="col" className="px-3 py-4 text-center text-xs font-bold uppercase tracking-wider text-sage-600 sm:px-4 sm:text-sm" data-id="element-241" data-mp="26ath2ta4skee">
                    ✅ Con Vacaciones Presentes
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-242" data-mp="c1woxpbfd22z">
                {rows.map(row => <tr key={row.feature} className="border-t border-bark-800/[0.07]" data-id="element-243" data-mp="c0d9u21i8x2s">
                    <th scope="row" className="px-4 py-4 text-sm font-medium leading-snug text-bark-800 sm:px-6" data-id="element-244" data-mp="80kvt9tcdyq1">
                      {row.feature}
                    </th>
                    <td className="px-3 py-4 text-center text-xs text-bark-400 sm:px-4 sm:text-sm" data-id="element-245" data-mp="vpnnlahox7y9">
                      <span aria-hidden="true" className="block text-base" data-id="element-246" data-mp="qqkgzlm2ato6">
                        ❌
                      </span>
                      {row.without}
                    </td>
                    <td className="px-3 py-4 text-center text-xs font-semibold text-bark-800 sm:px-4 sm:text-sm" data-id="element-247" data-mp="ltu5zcp46o9m">
                      <span aria-hidden="true" className="block text-base" data-id="element-248" data-mp="36hyk1icwtuw0">
                        ✅
                      </span>
                      {row.with}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </Reveal>
      </div>
    </section>;
}